var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpSimple16Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1658 8.63335C10.3222 8.79798 10.5824 8.80465 10.747 8.64825C10.9117 8.49186 10.9183 8.23162 10.7619 8.067L6.30027 3.37051C6.2973 3.36735 6.29428 3.36422 6.29119 3.36112C6.21116 3.28076 6.10568 3.24025 6 3.24023C5.93924 3.24022 5.87841 3.2536 5.82232 3.28049C5.78119 3.30018 5.74271 3.32708 5.70881 3.36112C5.70572 3.36422 5.7027 3.36735 5.69973 3.37051L1.23807 8.067C1.08167 8.23162 1.08835 8.49186 1.25297 8.64825C1.4176 8.80465 1.67783 8.79798 1.83422 8.63335L6 4.24832L10.1658 8.63335Z",
    fill: "#9375DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpSimple16Regular);
export default __webpack_public_path__ + "static/media/icon_up_simple_16_Regular.4049ea25.svg";
export { ForwardRef as ReactComponent };